import React, { memo, useCallback, useMemo, useRef, useState, } from "react";
import cx from "classnames";
import { Textarea } from "@smartsuite/react-ui/lib/components/forms/Textarea/Textarea";
import { useEditorImageResize } from "./useEditorImageResize";
import { text } from "./EditorImage.text";
const MIN_WIDTH = 216;
const MAX_WIDTH = 683;
function calcWidth(width, delta) {
    return Math.max(Math.min(width + delta, MAX_WIDTH), MIN_WIDTH);
}
export const EditorImage = memo(function EditorImage({ attrs, service, editable, onCaptionChange, onCaptionFocus, onCaptionBlur, onResize, onChangeMenuVisibility, }) {
    var _a;
    const textareaRef = useRef();
    const showCaption = editable || attrs.caption;
    const src = useMemo(() => service.getImageUrl(attrs), [attrs, service]);
    const [width, setWidth] = useState(((_a = attrs.size) === null || _a === void 0 ? void 0 : _a.width) || 400);
    const { leftHandleRef, rightHandleRef } = useEditorImageResize({
        onResize: useCallback((delta) => {
            setWidth(() => calcWidth(attrs.size.width, delta));
        }, [attrs.size.width]),
        onRelease: useCallback((delta) => {
            onResize({ width: calcWidth(attrs.size.width, delta) });
        }, [attrs.size.width, onResize]),
    });
    return (React.createElement("div", { className: cx("editor-image", `editor-image--${attrs.alignment}`), onMouseEnter: (e) => onChangeMenuVisibility(true, e.target), onMouseLeave: (e) => onChangeMenuVisibility(false, e.target), onDragOver: (e) => {
            e.stopPropagation();
        } },
        React.createElement("div", { className: "editor-image__wrap", style: { width } },
            React.createElement("img", { src: src, alt: attrs.caption, draggable: false }),
            React.createElement("div", { ref: leftHandleRef, className: "editor-image__resizer editor-image__resizer--left" }),
            React.createElement("div", { ref: rightHandleRef, className: "editor-image__resizer editor-image__resizer--right" })),
        showCaption && (React.createElement(Textarea, { ref: textareaRef, autoHeight: true, value: attrs.caption, className: "editor-image__caption", placeholder: text.writeCaption, maxLength: 150, disabled: !editable, onChange: (e) => {
                onCaptionChange(e.target.value);
                e.stopPropagation();
            }, onKeyDown: (e) => e.stopPropagation(), onKeyPress: (e) => e.stopPropagation(), onPaste: (e) => e.stopPropagation(), onClick: (e) => {
                textareaRef.current.focus();
                e.stopPropagation();
            }, onMouseDown: (e) => e.stopPropagation(), onFocus: onCaptionFocus, onBlur: onCaptionBlur }))));
});
